import { Navigate, useParams } from 'react-router'

import AppFooter from '../components/layout/AppFooter'
import AppHeader from '../components/layout/AppHeader'
import Shell from '../components/layout/Shell'
import VerificationEmailCard from '../components/verification/VerificationEmailCard'
import {
  CONTACT_VERIFICATION_EMAIL_VALIDATED_KEY,
  CONTACT_VERIFICATION_ENTRY_TOKEN_KEY,
  CONTACT_VERIFICATION_PHONE_VALIDATED_KEY,
  CONTACT_VERIFICATION_PROCESS_STATUS_KEY,
  CONTACT_VERIFICATION_TOKEN_KEY,
  getItemFromLS,
} from '../core/api'

export default function VerificationEmailPage() {
  const { verificationToken = '' } = useParams()
  const hasActiveSession =
    getItemFromLS(CONTACT_VERIFICATION_ENTRY_TOKEN_KEY) === verificationToken &&
    getItemFromLS(CONTACT_VERIFICATION_TOKEN_KEY)

  if (!hasActiveSession) {
    return <Navigate to={`/verify/${verificationToken}`} replace />
  }

  if (getItemFromLS(CONTACT_VERIFICATION_PROCESS_STATUS_KEY)) {
    return <Navigate to={`/verify/${verificationToken}/status`} replace />
  }

  if (getItemFromLS(CONTACT_VERIFICATION_PHONE_VALIDATED_KEY)) {
    return <Navigate to={`/verify/${verificationToken}/review`} replace />
  }

  if (getItemFromLS(CONTACT_VERIFICATION_EMAIL_VALIDATED_KEY)) {
    return <Navigate to={`/verify/${verificationToken}/phone`} replace />
  }

  return (
    <Shell>
      <AppHeader />
      <VerificationEmailCard />
      <AppFooter />
    </Shell>
  )
}
